import { Card, CardHeader, Typography } from "@mui/material";
import React from "react";
import { MdAttachMoney } from "react-icons/md";

const EpaymentTransactionsHeader = () => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            المعاملات المالية
          </Typography>
        }
        avatar={<MdAttachMoney size={20} />}
      />
    </Card>
  );
};

export default EpaymentTransactionsHeader;
